/*eslint-env node */
const $defaConfig = {
	baseURI: process.env.BASE_URI,
	googleAnalyticsTrackingCode: process.env.GOOGLE_ANALYTICS_CODE,
	googleMapsCode: process.env.LINK_GOOGLE_API_KEY
};

module.exports = $defaConfig;
